<template>
  <el-card shadow="hover" class="login-box">
    <div class="login-box-title">管理后台</div>
    <el-input placeholder="请输入账号" clearable v-model="loginForm.account" class="login-list-item">
      <i class="qj-icon-user" slot="prepend"></i>
    </el-input>
    <el-input placeholder="请输入密码" type="password" v-model="loginForm.password" show-password class="login-list-item" @keyup.enter.native="doLogin">
      <i class="qj-icon-lock" slot="prepend"></i>
    </el-input>
    <el-checkbox v-model="loginForm.remember" style="margin-top: 10px">记住密码</el-checkbox>
    <el-button type="primary" class="login-list-item" @click="doLogin">{{loginText}}</el-button>
  </el-card>
</template>

<script>
export default {
  name: "LoginBox",
  data() {
    return {
      loginForm: { account: '', password: '', remember: false },
      loginText: '登录'
    };
  },
  created () {
    this.getRemenberedMsg();
  },
  methods: {
    getRemenberedMsg () { // 显示上次记住的账号密码
      var old = this.$storage.get('LoginMessage');
      if (old) {
        this.loginForm = old;
      }
    },
    doLogin () { // 登录
      var self = this;
      // 验证账号密码是否合法
      // if (!this.$regular.isMobileNumber(this.loginForm.account)) {
      //   this.$message.error('请输入正确的手机号');
      //   return;
      // }
      if (!this.$regular.isPassword(this.loginForm.password)) {
        this.$message.error('密码长度为6-20个字符，由英文字母、数字、及下划线组成');
        return;
      }
      this.loginText = '登录中...';
      this.$store.dispatch('doUserLogin', this.loginForm)
        .then(function (res) {
          self.loginText = '登录';
          self.$router.push({ path: '/goods' });
        })
        .catch(function (err) {
          self.$message.error(err);
          self.loginText = '登录';
        })
    }
  }
}
</script>

<style scoped>
  .login-box{
    width: 100%;
    max-width: 400px;
    margin: 100px auto 0;
  }
  .login-box-title{
    width: 100%;
    line-height: 80px;
    text-align: center;
    font-size: 40px;
    font-family: qj_font_3;
  }
  .login-list-item{
    width: 100%;
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/views/login/LoginBox.vue